<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1 style="padding-top:100px;">Acknowledgments</h1>
<p style="text-align:center">The author acknowledges the considerable contributions that the following have made to the book:</p>
<p style="text-align:center">Barbara Ashworth, Beth Ashworth, Diane Bull, Digby and Sophie Degerholm, Frazer Hunt.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?66661548